import type { CityConfig } from "../city-template/types";

export const danvilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Kentucky Vital Records (Birth, Death, Marriage, Divorce)", href: "https://chfs.ky.gov/agencies/dph/dehp/vsb/", description: "Official Kentucky Office of Vital Statistics in Frankfort" },
    { label: "Boyle County Clerk — Marriage Licenses", href: "https://boylecounty.net/", description: "Boyle County Clerk — marriage license issuance" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Kentucky OVS for online vital record orders" },
  ],
  city: "Danville",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "danville",
  route: "/danville",
  title: "Emergency Passport Danville, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Danville, KY — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Boyle County, Centre College students, and historic downtown district residents. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Danville, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Danville and Boyle County travelers get their expedited passports as quickly as 24 hours. Serving Centre College students, historic downtown residents, and the growing Danville community. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Danville%20Kentucky%20historic%20downtown%20district%20with%20charming%20Main%20Street%20buildings%2C%20Centre%20College%20campus%20visible%20with%20historic%20academic%20architecture%2C%20Boyle%20County%20courthouse%20with%20red%20brick%20building%2C%20small%20college%20town%20atmosphere%20with%20tree-lined%20streets%2C%20warm%20afternoon%20sunlight%2C%20clean%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20panoramic%20view%20of%20Kentucky%20small%20town%20with%20rolling%20hills%20background%2C%20wide%20landscape%20view&width=1800&height=700&seq=danville-hero-001&orientation=landscape",
  heroImageAlt: "Danville Kentucky historic downtown with Centre College campus and Boyle County courthouse at golden hour",
  geoPosition: "37.6456;-84.7722",
  geoPlacename: "Danville, Kentucky",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 380 miles from Danville via I-75 and I-90",
  },
  nearbyCitiesZips: [
    { name: "Danville", zips: "40422, 40423" },
    { name: "Harrodsburg", zips: "40330" },
    { name: "Stanford", zips: "40484" },
    { name: "Lancaster", zips: "40444" },
    { name: "Richmond", zips: "40475, 40476" },
    { name: "Berea", zips: "40403, 40404, 40405, 40406, 40461, 40468, 40476, 40488, 40489, 40490, 40492, 40461" },
    { name: "Nicholasville", zips: "40356, 40340" },
    { name: "Lexington", zips: "40502, 40503, 40504, 40505, 40506, 40507, 40508, 40509, 40510, 40511, 40513, 40514, 40515, 40516, 40517, 40526, 40533, 40536, 40544, 40546, 40550, 40555, 40574, 40575, 40576, 40577, 40578, 40579, 40580, 40581, 40582, 40583, 40588, 40591, 40598" },
    { name: "Frankfort", zips: "40601, 40602, 40603, 40604, 40618, 40619, 40620, 40621, 40622" },
    { name: "Versailles", zips: "40383, 40384, 40385, 40386" },
    { name: "Winchester", zips: "40391, 40392" },
    { name: "Mount Vernon", zips: "40456" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Boyle County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Lexington", route: "/lexington" },
    { name: "Fast passport renewal in Frankfort", route: "/frankfort" },
    { name: "Emergency passport help in Berea", route: "/berea" },
    { name: "Urgent passport services in Richmond", route: "/richmond" },
    { name: "Same-day passport help in Georgetown", route: "/georgetown" },
    { name: "Passport courier services near Harrodsburg", route: "/harrodsburg" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Danville remotely via secure courier. We do not have a walk-in office in Danville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Boyle County travelers.",
  fpcOfficeAddress: "500 W Jefferson St, Louisville, KY 40202",
  fpcOfficeDistance: "Serving all of Boyle County and the historic Danville region",
  serviceAreaIntro: "From the historic Danville downtown to the Centre College campus, from the Wilderness Trail Distillery to the growing residential neighborhoods — Fast Passport Center serves the entire Danville community and surrounding region. We regularly help travelers from Harrodsburg, Stanford, and Lancaster get their passports fast.",
  nearbyCitiesIntro: "We serve all Danville neighborhoods and nearby Boyle County cities including Harrodsburg, Stanford, Lancaster, Richmond, Berea, Nicholasville, Lexington, Frankfort, Versailles, Winchester, and Mount Vernon. If you are in Boyle County, central Kentucky, or the Danville region, we have you covered.",
  howItWorksIntro: "Most Danville travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Danville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Danville and Boyle County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Danville? Here are the most common ones we hear from Boyle County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Boyle County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rebecca S.",
      location: "Danville, KY",
      rating: 5,
      text: "I'm a professor at Centre College and needed a passport for a research conference in London. Fast Passport Center renewed mine in 4 days. They understand academic travel timelines and made the process completely stress-free.",
      service: "Passport Renewal",
    },
    {
      name: "Tyler M.",
      location: "Danville, KY",
      rating: 5,
      text: "My daughter at Centre College needed a passport for a study abroad semester in Spain. Fast Passport Center helped with her new passport and got it done in 5 days. Perfect for college students with tight academic deadlines.",
      service: "New Passport",
    },
    {
      name: "Linda P.",
      location: "Harrodsburg, KY",
      rating: 5,
      text: "We planned a Mediterranean cruise for our anniversary and I realized my passport had expired two weeks before. Fast Passport Center got my renewal done in 3 days. Saved our anniversary trip to Greece and Italy.",
      service: "Passport Renewal",
    },
    {
      name: "Charles D.",
      location: "Stanford, KY",
      rating: 5,
      text: "Had an emergency family situation requiring travel to Ireland within 72 hours. Fast Passport Center processed my emergency passport in 24 hours. Their professionalism during a stressful time was incredible.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "danville-1",
      name: "Danville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 E Main St",
      city: "Danville",
      state: "KY",
      zip: "40422",
      phone: "(859) 236-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Danville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Boyle County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-2",
      name: "Boyle County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "321 W Main St",
      city: "Danville",
      state: "KY",
      zip: "40422",
      phone: "(859) 238-1110",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Boyle County Courthouse",
      website: "https://www.boylecounty.com/",
      websiteLabel: "Boyle County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "danville-3",
      name: "Harrodsburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Broadway",
      city: "Harrodsburg",
      state: "KY",
      zip: "40330",
      phone: "(859) 734-2211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Harrodsburg",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Mercer County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-4",
      name: "Stanford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 E Main St",
      city: "Stanford",
      state: "KY",
      zip: "40484",
      phone: "(606) 365-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Stanford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lincoln County. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-5",
      name: "Richmond Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "140 N Madison Ave",
      city: "Richmond",
      state: "KY",
      zip: "40475",
      phone: "(859) 623-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles from Danville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Madison County residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "danville-6",
      name: "Berea Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 N Broadway",
      city: "Berea",
      state: "KY",
      zip: "40403",
      phone: "(859) 986-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles from Danville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Madison County residents. Convenient for Berea area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Danville area photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Boyle County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Danville applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Boyle County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Central Kentucky travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Danville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Danville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Danville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Danville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6.5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Danville?", a: "Fast Passport Center offers fast passport renewal in Danville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Danville in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Danville?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 6.5 hour drive from Danville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Boyle County residents." },
    { q: "Can I expedite a child passport in Danville?", a: "Yes. Fast Passport Center expedites child passports in Danville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Boyle County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Danville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Danville?", a: "With Fast Passport Center's emergency courier service, Danville travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Danville?", a: "Popular options include the Danville Post Office (40422), Boyle County Clerk (40422), Harrodsburg Post Office (40330), Stanford Post Office (40484), Richmond Main Post Office (40475), and Berea Post Office (40403). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Danville?", a: "Same-day passports are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 6.5 hour drive to Chicago." },
    { q: "What if I live in a smaller Boyle County town?", a: "We serve the entire Boyle County region including Harrodsburg, Stanford, Lancaster, Richmond, Berea, Nicholasville, Lexington, Frankfort, Versailles, Winchester, and Mount Vernon. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Danville?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Danville?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Danville offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Danville?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Danville?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Boyle County families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Danville", address: "1560 Hustonville Rd, Danville, KY 40422", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Danville", address: "1001 N Broadway, Danville, KY 40422", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "Walmart — Danville", address: "1000 E Lexington Ave, Danville, KY 40422", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/photo/1078904" },
    { name: "Rite Aid — Danville", address: "645 S 4th St, Danville, KY 40422", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/photo" },
    { name: "CVS Pharmacy — Harrodsburg", address: "609 W Broadway, Harrodsburg, KY 40330", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walmart — Richmond", address: "820 Eastern Bypass, Richmond, KY 40475", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/photo/1078904" },
    { name: "Walgreens — Berea", address: "200 Paint Lick Rd, Berea, KY 40403", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Danville", address: "100 E Main St, Danville, KY 40422", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Boyle County",
      address: "321 W Main St, Danville, KY 40422",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Mercer County",
      address: "250 E Office St, Harrodsburg, KY 40330",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: false,
    },
    {
      name: "Circuit Court Clerk — Madison County",
      address: "135 W Irvine St, Richmond, KY 40475",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center for Richmond area residents.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Lincoln County",
      address: "102 W Main St, Stanford, KY 40484",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Alternative for Lincoln County residents. Walk-ins limited.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "35 miles from Danville",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "The closest major airport for Boyle County travelers. Domestic flights with connections to major international hubs.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: true,
    },
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "75 miles from Danville",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative regional airport with flights to major hubs.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: false,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International",
      distance: "100 miles from Danville",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-75.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: false,
    },
  ],
};